import {IncludeChunk} from "../chunks/types/IncludeChunk";
import {IncludeDef} from "./types/IncludeDef";

export function includeChunkToIncludeDef(
  includeChunk: IncludeChunk
): IncludeDef {
  const {
    captures: {
      1: stringChunk
    }
  } = includeChunk;
  return {
    location: stringChunk.captures[0]
  };
}